import React, { useState } from "react";
import { usePriceBlocsContext } from "@priceblocs/react-priceblocs-js";
import Summary from "../Invoices/Summary";
import ActionButton from "../ActionButton";
import Loader from "./Loader";
import Button from "components/Form/fields/Button";
import usePreviewInvoice from "utils/hooks/usePreviewInvoice";
import { BUTTON_CLASS_CONTEXT } from "utils/constants/ui";

const PreviewInvoice = ({
  prices,
  subscription,
  afterConfirm,
  title,
  setOpen
}) => {
  const [confirming, setConfirming] = useState(false);
  const { updateSubscription } = usePriceBlocsContext();

  const { data, loading: previewing } = usePreviewInvoice({
    subscription,
    prices
  });

  const confirm = async () => {
    if (!confirming) {
      setConfirming(true);
      const updateInput = {
        id: subscription.id,
        ...data.preview.confirm
      };
      const updatedSub = await updateSubscription(updateInput);
      if (updatedSub && updatedSub.statusCode !== 400) {
        setConfirming(false);
        afterConfirm();
      } else {
        setConfirming(false);
      }
    }
  };

  let content;
  const disabled = Boolean(previewing);
  if (previewing) {
    content = <Loader />;
  } else if (
    data &&
    data.preview &&
    data.preview.lineItems &&
    data.preview.amountItems
  ) {
    const { lineItems, amountItems } = data.preview;
    content = <Summary lineItems={lineItems} amountItems={amountItems} />;
  }

  return (
    <div className="h-100 flex flex-column bg-white">
      <div className="min-h-0 flex-1 flex flex-column pv3 overflow-y-scroll">
        <div className="flex items-start justify-between pa3">
          {title && <div className="f4 fw6">{title}</div>}
        </div>

        <div className="mt3 relative flex-1 ph3">
          <div className="pv3">{content}</div>
        </div>
      </div>
      <div className="flex-shrink-0 pa3 flex justify-end">
        <div className="pr2">
          <Button
            classes={{
              contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
            }}
            onClick={() => setOpen(false)}
            copy="Cancel"
          />
        </div>
        <ActionButton
          loading={confirming}
          onClick={confirm}
          disabled={disabled || confirming}
          copy={{ value: "Update" }}
        />
      </div>
    </div>
  );
};

export default PreviewInvoice;
